export class IntervalSplitEntity {
  yearly!: number
  monthly!: number
}

export class SubscriberIntervalsEntity {
  total!: IntervalSplitEntity
  new!: IntervalSplitEntity
  churn!: IntervalSplitEntity
}
